import React, { FC } from "react";
import { IconButton } from "@evergis/ui";
import { ImagePreview, ImageMask, ImageWrapper } from "./styled";

type ImageAttributeProps = {
  src: string;
  onDelete: (src: string) => void;
  onExpand: (src: string) => void;
  isEdit?: boolean;
};

export const ImageAttribute: FC<ImageAttributeProps> = ({ src, isEdit, onDelete, onExpand }) => {
  return (
    <ImageWrapper onClick={() => onExpand(src)}>
      {isEdit && (
        <ImageMask>
          <IconButton
            kind={"delete"}
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              e.stopPropagation();
              onDelete(src);
            }}
          />
        </ImageMask>
      )}
      <ImagePreview src={src} />
    </ImageWrapper>
  );
};
